import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Customecommerceportfolio() {
  return (
    <section className="custom-ecommerce-portfolio p-100">
      <Container>
        <Swiper
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          // autoplay={false}
          pagination={{ clickable: true }}
          spaceBetween={10}
          modules={[Autoplay, Pagination]}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
          }}
          className="portfolio-slider"
        >
          <SwiperSlide>
            <div className="ecomm-port-box">
              <h2 className="text-center mb-5">
                Blockchain Game Success by TekRevol
              </h2>
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="mb-4 mb-lg-0"
                >
                  <div className="icon">
                    <StaticImage
                      src="../../images/services-usa/web3/ether-legends-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={100}
                      height={50}
                    />
                  </div>
                  <div className="content">
                    <h3>Ether Legends</h3>
                    <p>
                      Ether Legends sought a robust blockchain-based NFT trading
                      card game to engage players. TekRevol developed a scalable
                      platform integrating Enjin, Polygon, and Ethereum, fixing
                      prior development issues. Features included seamless NFT
                      wallet connectivity, PVP battles, and tokenized
                      collectibles, delivering an immersive play-to-earn
                      experience.
                    </p>
                    <h5>The result</h5>
                    <ul>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Increased player engagement by 35% monthly.
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Boosted NFT transactions by 50% post-launch.
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Reduced backend errors by 20% immediately.
                      </li>
                    </ul>
                    <Link
                      style={{ background: "#f47a14", color: "#fff" }}
                      to="/case-studies/ether-legends"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                    >
                      View Case Study
                    </Link>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="text-center my-auto"
                >
                  <StaticImage
                    src="../../images/services-usa/web3/ether-legends.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={728}
                    height={425}
                  />
                </Col>
              </Row>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="ecomm-port-box">
              <h2 className="text-center mb-5">
                Blockchain Loyalty Success by TekRevol
              </h2>
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="mb-4 mb-lg-0"
                >
                  <div className="icon">
                    <StaticImage
                      src="../../images/services-usa/web3/revcoin-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={72}
                      height={50}
                    />
                  </div>
                  <div className="content">
                    <h3>Rev Coin</h3>
                    <p>
                      Rev Coin envisioned a blockchain-based solution to
                      transform employee benefits. TekRevol crafted an ERC20
                      token on Ethereum, integrating smart contracts for secure,
                      transparent transactions. The platform enabled employees
                      to hold company shares, track holdings via etherscan.io,
                      and access exclusive rewards, fostering loyalty and
                      ownership.
                    </p>
                    <h5>The result</h5>
                    <ul>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Boosted employee retention by 30% annually.
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Increased benefit engagement by 45% post-launch.
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Reduced transaction errors by 25% instantly.
                      </li>
                    </ul>
                    <Link
                      style={{ background: "#f47a14", color: "#fff" }}
                      to="/case-studies/rev-coin"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                    >
                      View Case Study
                    </Link>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="text-center my-auto"
                >
                  <StaticImage
                    src="../../images/services-usa/web3/revcoin.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={728}
                    height={425}
                  />
                </Col>
              </Row>
            </div>
          </SwiperSlide>
        </Swiper>
      </Container>
    </section>
  );
}

export default Customecommerceportfolio;
